'use strict';

import _ from 'lodash';

export default function () {
  return {
    controller: function($scope, $http, $sce, $timeout, $interval, $uibModal) {
      'ngInject';

      $scope.rotation = [];
      for(var i = 0; i < 99; i++) {
        var num = Math.random() * 6 - 3;
        $scope.rotation[i] = `rotate(${num}deg)`;
      }

      $scope.Popup = function Popup(image) {
        $uibModal.open({
          templateUrl: 'ImageFeaturePopup',
          size: 'lg',
          scope: $scope,
          windowClass: 'ImageFeaturePopup',
          controller: function($scope, $uibModalInstance) {
            $scope.image = image;
          }
        });
      };

    },
    template: require('./imageFeature.html'),
    link: function (scope, element, attr, ngModel) {
      var imageFeature = $(element).find('.ImageFeature');
      var parent = $(element).parent();
      var images = $(element).find(".Image");
      parent.css({ overflow: 'hidden', position: 'relative' });

      var left = 0;
      setInterval(function() {
        if(parent.is(":hover")) {
          return;
        }
        if(images.length == 0) {
          images = $(element).find(".Image");
          images.each(function(index) {
            $(this).css({ left: index * $(this).outerWidth(true) + "px" });
          });
        }
        left--;
        imageFeature.css({ left: left + 'px' });

        images.each(function(index) {
          var image = $(this);
          if(image.offset().left + images.outerWidth() < 0) {
            var prevImage = index == 0 ? images.last() : images.eq(index - 1);
            console.log(index, prevImage, prevImage.position().left);
            image.css({ left: prevImage.position().left + prevImage.outerWidth(true) + "px" });
          }
        });
      }, 20);
    }
  };
};



// WEBPACK FOOTER //
// ./sgcontenteditor/customElements/imageFeature.js